import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { handleCalendarChange } from 'actions/tasks'
import DateTimePicker from 'components/theme/DateTimePicker'
// import language from 'utils/vast-languagepack'

export default connect(
  (state, { modal }) => {
    if (!modal) {
      const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
      const stats = task?.sms_stats || task?.email_stats
      const campaignStatus =
        state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
      const automationTypeSelected =
        state.tasks.addOrEdit.automationTypeSelected
      const disabled = Boolean(
        (stats && automationTypeSelected !== 'stage') ||
          campaignStatus === 'L' ||
          campaignStatus === 'C',
      )

      return {
        value: state.tasks.addOrEdit.fields.date.value,
        error: state.tasks.addOrEdit.fields.date.error
          ? state.tasks.addOrEdit.fields.date.error
          : null,
        search: state.router.location.search,
        disabled,
      }
    }

    return {
      value: state.tasks.addOrEdit.fields.date.value,
      error: state.tasks.addOrEdit.fields.date.error
        ? state.tasks.addOrEdit.fields.date.error
        : null,
    }
  },
  dispatch =>
    bindActionCreators(
      {
        handleChange: handleCalendarChange,
      },
      dispatch,
    ),
)(props =>
  props.disabled ? null : (
    <>
      <DateTimePicker
        // noMin={props.disabled}
        {...props}
        title="Day & time"
        helperText={
          props.modal
            ? null
            : 'You cannot schedule a task for a time in the past.'
        }
      />
    </>
  ),
)
